import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { Dashboard } from './pages/Dashboard'
import { Employees } from './pages/Employees'
import { Departments } from './pages/Departments'
import { Positions } from './pages/Positions'
import { Schedules } from './pages/Schedules'
import { Attendance } from './pages/Attendance'
import { BioTerminalCards } from './pages/BioTerminalCards'
import { TimeRecords } from './pages/TimeRecords'
import { Reports } from './pages/Reports'
import { LocationsPage } from './components/locations/LocationsPage'
import { Notifications } from './pages/Notifications'
import { Documents } from './pages/Documents'
import { Profile } from './pages/Profile'
import { Settings } from './pages/Settings'
import { Medications } from './pages/Medications'
import { MarkirovkaStock } from './pages/MarkirovkaStock'
import { MarkirovkaDocuments } from './pages/MarkirovkaDocuments'
import { MarkirovkaRecon } from './pages/MarkirovkaRecon'
import { AssignmentScans } from './pages/AssignmentScans'
import { PharmaAnalytics } from './pages/PharmaAnalytics'
import { StockRequisitions } from './pages/StockRequisitions'
import { Roles } from './pages/Roles'
import { Users } from './pages/Users'
import { Login } from './pages/Login'
import { Register } from './pages/Register'
import { Licensing } from './pages/Licensing'
import { NotFound } from './pages/NotFound'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { RequireSectionRoute } from './components/auth/RequireSectionRoute'
import './App.css'

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        {/* Реестр лицензий: кросс-тенантный, доступ только суперадмину —
            проверка внутри самой страницы, как на SuperAdmin. Раньше маршрут
            был публичным, вместе с API. */}
        <Route path="licensing" element={<Licensing />} />
        <Route path="employees" element={<RequireSectionRoute section="employees"><Employees /></RequireSectionRoute>} />
        <Route path="departments" element={<RequireSectionRoute section="departments"><Departments /></RequireSectionRoute>} />
        <Route path="positions" element={<RequireSectionRoute section="positions"><Positions /></RequireSectionRoute>} />
        <Route path="locations" element={<RequireSectionRoute section="locations"><LocationsPage /></RequireSectionRoute>} />
        <Route path="schedules" element={<RequireSectionRoute section="schedules"><Schedules /></RequireSectionRoute>} />
        <Route path="attendance" element={<RequireSectionRoute section="attendance"><Attendance /></RequireSectionRoute>} />
        <Route path="bio-cards" element={<RequireSectionRoute section="attendance"><BioTerminalCards /></RequireSectionRoute>} />
        <Route path="time-records" element={<RequireSectionRoute section="time_records"><TimeRecords /></RequireSectionRoute>} />
        <Route path="reports" element={<RequireSectionRoute section="reports"><Reports /></RequireSectionRoute>} />
        <Route path="notifications" element={<RequireSectionRoute section="notifications"><Notifications /></RequireSectionRoute>} />
        <Route path="documents" element={<RequireSectionRoute section="documents"><Documents /></RequireSectionRoute>} />
        <Route path="settings" element={<RequireSectionRoute section="settings"><Settings /></RequireSectionRoute>} />
        <Route path="users" element={<RequireSectionRoute section="users"><Users /></RequireSectionRoute>} />
        <Route path="roles" element={<RequireSectionRoute section="roles"><Roles /></RequireSectionRoute>} />
        <Route path="medications" element={<RequireSectionRoute section="medications"><Medications /></RequireSectionRoute>} />
        <Route path="markirovka-stock" element={<RequireSectionRoute section="markirovka_stock"><MarkirovkaStock /></RequireSectionRoute>} />
        <Route path="markirovka-documents" element={<RequireSectionRoute section="markirovka_documents"><MarkirovkaDocuments /></RequireSectionRoute>} />
        <Route path="markirovka-recon" element={<RequireSectionRoute section="markirovka_recon"><MarkirovkaRecon /></RequireSectionRoute>} />
        <Route path="assignment-scans" element={<RequireSectionRoute section="assignment_scans"><AssignmentScans /></RequireSectionRoute>} />
        <Route path="pharma-analytics" element={<RequireSectionRoute section="pharma_analytics"><PharmaAnalytics /></RequireSectionRoute>} />
        <Route path="stock-requisitions" element={<RequireSectionRoute section="stock_requisitions"><StockRequisitions /></RequireSectionRoute>} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
